import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useStore } from "@/stores/useStore";

export const useIsTenantMember = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowedTenants = useStore((s) => s.allowedTenants);

  useEffect(() => {
    if (!allowedTenants) return;
    if (allowedTenants.length === 0 && location.pathname !== "/setup") {
      navigate("/setup");
    }
  }, [navigate, allowedTenants, location]);
};
